const OriginalityDeviceDefaultSteps={
    CREATE_PAYMENT:'CreatePayment',
    SET_ITEMS:'SetItems',
    PAYMENT_INQUIRY:'InquiryPayment',
    SHAHKAR:'Shahkar',
    INIT_CONFIRM:'InitConfirm',
    IMEI_INQUIRY:"IMEIInquiry",
    FINAL:"Final",

}
export {OriginalityDeviceDefaultSteps}